export const loadFont = async (properties) => {
    try {
        const response = await fetch(properties.src, { credentials: "omit" });
        const fontData = await response.arrayBuffer();
        const fontFace = new FontFace(properties["font-family"], fontData, {
            display: "block",
            weight: String(properties["font-weight"]),
            style: properties["font-style"]
        });
        await fontFace.load();
        document.fonts.add(fontFace);
        console.debug(`font-family: '${fontFace.family}'`);
    }
    catch (error) {
        console.error(error);
    }
};
